export enum ChallengeStatusTagType {
  OPEN = 'Open',
  COMING_SOON = 'Coming Soon',
  CLOSED = 'Closed',
  DRAFT = 'Draft',
}
